export const CONTROLLER_INCLUDED_HARDWARE = [
    'AXC F 2152 PLCnext controller',
    'AXL F BP SE4 Axioline F backplane',
    'AXL SE AI4 analog input module',
    'AXL SE DI16/1 digital input module',
    'AXL SE DO16/1 digital output module',
];
